const unemploymentReasons = [
  "Disabled",
  "Homemaker",
  "Student",
  "Retired",
  "Unemployed",
];

export default unemploymentReasons;
